import React from 'react';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import { Modal } from 'react-bootstrap';
import './ConfirmationModal.scss';
import { FormattedMessage } from 'react-intl';

interface Props {
  show: boolean;
  setHide: any;
  title: string;
  message: string;
  confirmationButton: string;
  doAction: () => void;
}

const ConfirmationModal = ({ show, setHide, title, message, confirmationButton, doAction }: Props) => {
  return (
    <Modal
      show={show}
      onHide={setHide}
      backdrop='static'
      size='lg'
      keyboard={false}
      className='order-quote-modal'
      centered
      backdropClassName='order-quote-backdrop'
    >
      <Modal.Header closeButton className='border-bottom'>
        <Modal.Title>
          <h2>{title}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='confirmation-border d-flex flex-column gap-4 justify-content-center align-items-center'>
          <div>
            <KitIcons.AlertTriangleIcon />
          </div>
          <p>{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className='top-border'>
        <div className='d-flex flex-row gap-4'>
          <Button
            buttonType={EButtonType.BasicLink}
            onClick={() => {
              setHide();
            }}
          >
            <FormattedMessage id='ec.checkout.cancel' defaultMessage='Abbrechen' />
          </Button>
          <Button
            buttonType={EButtonType.InvertedPillLarge}
            onClick={() => {
              doAction();
            }}
          >
            {confirmationButton}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
